import React, { useState, useEffect } from 'react';
import { Modal } from '@mui/material';
// import { APIProvider, Map, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useSpring, animated } from '@react-spring/web';

const RotatingPiece = () => {

    // Animation for rotation
    const styles = useSpring({
      from: { rotateZ: 0 },
      to: { rotateZ: 360 },
      config: { duration: 2000 },
      loop: true,
    });
  
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto', border: '1px solid black' }}>
            <svg width="100%" height="100%" viewBox="0 0 100 100">

                {/* Static piece */}
                <circle cx="50" cy="50" r="10" fill="#dedede" />

                {/* Rotating piece */}
                <animated.circle
                    cx="50"
                    cy="50"
                    r="10"
                    fill="#06caff"
                    style={styles}
                />
                
            </svg>
        </div>
    );
};

const Directions = ({ origin, destination }) => {

    // const map = useMap();
    // const routesLibrary = useMapsLibrary('routes');

    const [directionsService, setDirectionsService] = useState();
    const [directionsRenderer, setDirectionsRenderer] = useState();
    const [routes, setRoutes] = useState([]);
    const [routeIndex, setRouteIndex] = useState(0);

    const selected = routes[routeIndex];
    const leg = selected?.legs[0];
  
    // Initialize directions service and renderer
    // useEffect(() => {
    //     if (!routesLibrary || !map) return;
    //     setDirectionsService(new routesLibrary.DirectionsService());
    //     setDirectionsRenderer(new routesLibrary.DirectionsRenderer({ map }));
    // }, [routesLibrary, map]);
  
    // Use directions service
    useEffect(() => {
        if ( !directionsService || !directionsRenderer ) 
            return;
    
        directionsService
            .route({
                origin: origin,
                destination: destination,
                travelMode: 'DRIVING',
                provideRouteAlternatives: true
            })
            .then(response => {
                directionsRenderer.setDirections(response);
                setRoutes(response.routes);
            });
    
        return () => directionsRenderer.setMap(null);
    }, [directionsService, directionsRenderer, destination, origin]);
  
    // Update direction route
    useEffect(() => {
        if (!directionsRenderer) return;
        directionsRenderer.setRouteIndex(routeIndex);
    }, [routeIndex, directionsRenderer]);
  
    if (!leg) return null;
  
    return null;
};

const TripModal = ({ isDisplay, trip, onClose }) => {

    console.log('TripModal trip', trip)

    return (
        <Modal
            open={isDisplay}
            onClose={() => {}}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div className='
                relative
                flex flex-col items-center justify-start
                w-[950px] h-auto
                mt-[100px]
                ml-auto mr-auto
                bg-white
                shadow-[-1px_-1px_5px_5px_rgba(0,0,0,0.2)]
                rounded-[5px]
                overflow-hidden
                mb-[50px]
            '>
                
                <div className='flex flex-col w-full h-[400px]'>
                    {/* <Map
                        style={{ width: '120%', height: '120%' }}
                        defaultCenter={{lat: 22.54992, lng: 0}}
                        defaultZoom={3}
                        gestureHandling={'greedy'}
                        disableDefaultUI={true}
                    >
                        <Directions 
                            origin={trip.origin}
                            destination={trip.destination}
                        />
                    </Map> */}
                </div>

                <div className='
                    flex flex-col w-full h-auto justify-center items-center mt-[-25px] 
                    pl-[25px] pr-[25px] rounded-[25px] bg-[#ffffff] overflow-hidden pt-[25px]
                    shadow-[-1px_-1px_5px_5px_rgba(0,0,0,0.07)]
                '>  
                    <div className='
                        flex flex-row space-between justify-between items-start
                        w-full
                    '>
                        <div className='
                            flex flex-col w-[250px] mt-[25px] 
                            justify-center items-center
                        '>
                            <div className='
                                w-[15px] h-[15px] 
                                bg-[#94ebff] 
                                rounded-full
                            ' />
                            <span className='
                                w-full block mt-[15px]
                                font-["Hind"] font-black 
                                text-[#213568] text-center text-[20px] 
                                text-left leading-[20px]
                            '>
                                { trip?.departure }
                            </span>
                            <span className='
                                w-full block mt-[5px]
                                font-["Hind"] font-light italic
                                text-[#777777] text-center text-[14px] 
                                text-left leading-[15px]
                            '>
                                { trip?.departureGps }
                            </span>
                        </div>

                        <div className='
                            w-full h-[1px] bg-[#777777]
                        ' />
                        
                    </div>

                    <img 
                        className='w-[250px] h-[250px]'
                        src={require('./driver.png')}
                        alt='driver'
                    />
                    <div className='flex flex-col w-full ml-[35px]'>
                        <h2 className='text-[#353535] font-bold font-["Montserrat"] text-[24px] w-full text-left leading-[30px] tracking-wide mb-[25px]'>
                            Jean Dupont
                        </h2>
                        <div className='flex flex-row w-full justify-between align-between bg-[#fafafa] p-[15px] m-[5px] rounded-[5px]'>
                            <div className='w-auto m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Départ
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.origin }
                                </span>
                            </div>
                            <div className='w-[150px] m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Date
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.departure }
                                </span>
                            </div>
                        </div>
                        <div className='flex flex-row w-full justify-between align-between bg-[#fafafa] p-[15px] m-[5px] rounded-[5px]'>
                            <div className='w-auto m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Destination
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.destination }
                                </span>
                            </div>
                            <div className='w-[150px] m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Date
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.arrival }
                                </span>
                            </div>
                        </div>
                        <div className='flex flex-row w-full justify-between align-between p-[15px] m-[5px]'>
                            <div className='w-[150px] m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Distance
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.totalDistanceKm } km
                                </span>
                            </div>
                            <div className='w-[150px] m-[5px]'>
                                <h3 className='text-[#3c3c3c] tracking-normal uppercase font-semibold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                    Durée
                                </h3>
                                <span className='text-[#353535] font-light font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                    { trip?.duration }
                                </span>
                            </div>
                        </div>
                        <div className='w-[150px] mt-[10px] mb-[10px] bg-[#ffffff] p-[15px] shadow-[-1px_-1px_5px_5px_rgba(210,210,210,0.2)]'>
                            <h3 className='text-[#3c3c3c] tracking-normal uppercase font-bold font-["Montserrat"] leading-[15px] text-[13px] w-full text-left'>
                                Prix
                            </h3>
                            <span className='text-[#3c3c3c] font-bold font-["Montserrat"] text-[16px] w-full text-left leading-[25px] block tracking-wide'>
                                24.35€
                            </span>
                        </div>
                        <div className='flex mt-[15px]'>
                            <button
                                className='
                                    w-[150px] h-[40px] bg-[#06caff] text-[#ffffff] font-bold font-["Montserrat"] uppercase tracking-wider
                                    hover:bg-[#57dfff] rounded-[5px] 
                                    shadow-[-1px_-1px_5px_5px_rgba(49,192,255,0.2)]
                                '
                            >
                                Réserver
                            </button>
                        </div>
                    </div>
                </div>

                <div className='absolute right-[25px] top-[25px]'>
                    <button 
                        className='
                            w-[35px] h-[35px] bg-[#000000] text-[#ffffff] font-bold font-["Montserrat"] uppercase tracking-wider
                            hover:bg-[#ffffff] rounded-[5px] hover:text-[#000000]
                            shadow-[-1px_-1px_5px_5px_rgba(200,200,200,0.1)]
                        '
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Fermer
                    </button>
                </div>
                
            </div>
        </Modal>
    );
}

export default TripModal;